import { toast } from 'react-toastify'

import type { Id, ToastOptions, TypeOptions } from 'react-toastify'

import Toast from '~/components/Toast'

export const displayToast = (message: string, type: TypeOptions): Id => {
  const toastOptions: ToastOptions = {
    autoClose: 0,
    closeOnClick: true,
    hideProgressBar: true,
    pauseOnHover: true,
    position: 'bottom-center',
    progress: undefined,
    rtl: false,
    type,
  }

  return toast(<Toast content={`${message}${type === 'success' ? '!' : ''}`} />, toastOptions)
}
